import Beeswarm from './Beeswarm';
import Dateline from 'Components/common/Dateline';
import Globe from './Globe';
import Headline from './Headline';
import Logo from './Logo';
import Pace from './Pace';
import PriorityGroups from './PriorityGroups';
import PriorityGroupsIntro from './PriorityGroupsIntro';
import React from 'react';

const PageContent = (props) => {
  const {
    globalStatistics,
    vaccinationSummaryStatistics,
    priorityGroupsSummaryStatistics,
  } = props;

  return (
    <article>
      <div className='vaccine-page-top-logo'><Logo /> </div>
      <Dateline />

      <div className='section-spacer-internal' />
      <Headline {...{ vaccinationSummaryStatistics }} />


      <div className='section-spacer-internal' />
      <Globe {...{ vaccinationSummaryStatistics }} />
      <div className='section-spacer' />

      <Pace />
      <div className='section-spacer' />

      <div className='section-spacer-internal' />
      <Beeswarm {...{ vaccinationSummaryStatistics }} />
      <div className='section-spacer' />

      <div className='section-spacer-internal' />
      <PriorityGroupsIntro
        {...{ vaccinationSummaryStatistics, priorityGroupsSummaryStatistics }}
      />
      <div className='section-spacer' />

      <PriorityGroups
        {...{ globalStatistics, vaccinationSummaryStatistics, priorityGroupsSummaryStatistics }}
      />
      <div className='section-spacer internal' />
      <div className='footnote mx-auto'>
      Correction: A previous version of the globe at the top of this page included a calculation error that affected some countries' percent of population vaccinated figures.
      </div>

    </article>
  );
};

export default PageContent;
